import React from "react";
import { ReactComponent as NoDataPlaceholder } from "../../../../../../../assets/svg/noData.svg";
import "./NoData.scss";

function NoData(props) {
    return (
        <div className="noData">
            <div className="no__data-image">
                <NoDataPlaceholder />
            </div>
            {props.ruleEngine ? (
                <>
                    <p>Unlock more with Automation Engine.</p>
                    <p>Click on Create New button in the top right corner to add the rules.</p>
                </>
            ) : (
                <p>{props.message ? props.message : "No Data"}</p>
            )}
        </div>
    );
}
export default NoData;
